import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Zoom
} from '@material-ui/core';
import styles from './index.module.css';

export const WarningPopup = ({
  isVisible,
  onCancel,
  onContinue,
  title,
  message,
  cancelText = 'Cancel',
  continueText = 'Continue'
}) => (
    <Dialog
      open={isVisible}
      TransitionComponent={Zoom}
      keepMounted
      onClose={onCancel}
      aria-labelledby="warning-dialog-title"
      aria-describedby="warning-dialog-description"
      maxWidth="xs"
      fullWidth
      classes={{ paper: styles.dialogPaper }}
    >
      <DialogTitle className={styles.dialogTitle}>
        <div className={styles.title}>
          {title}
        </div>
      </DialogTitle>
      <DialogContent className={styles.mainContent}>
        <DialogContentText>
          <div className={styles.content}>
            {message}
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions className={styles.dialogActions}>
        <button
          className={styles.cancelButton}
          onClick={onCancel}
        >
          {cancelText}
        </button>
        <button
          className={styles.continueButton}
          onClick={onContinue}
        >
          {continueText}
        </button>
      </DialogActions>
    </Dialog>
  );
